module.exports = __webpack_public_path__ + "img/Quality Inspection.ca841b00.png";